<div class="w-100 h-100">
  <div class="select-context-container d-flex justify-content-between">
    <div class="context-list w-80">
      <bb-select-context-widget [showSearchAfter]="5" (selectContextSuccess)="selectContext()" (back)="logout()">
      </bb-select-context-widget>
    </div>
    <div class="banesco-contigo-logo"></div>
  </div>
</div>